import apiStarWars from '@/services/starWars';
import { ActionTree } from 'vuex';

const actions: ActionTree<Store.StarWars.ProtagonistState, RootState> = {
  async getProtagonist({ commit }): Promise<void> {
    commit('setProtagonist', await apiStarWars.people.protagonist());
  },
};

export default actions;
